export function Pilihan(props) {
  return (
    <label
      onClick={() => props.handleChange(props.value)}
      className="block px-3 py-2 rounded cursor-pointer font-bold border-[1px]"
    >
      {String.fromCharCode(props.value + 65)}
    </label>
  );
}
